import React, { createRef, PureComponent } from 'react';
import _ from 'lodash';

import {Config} from '../../util';
// import LogoUrl from '../../util/LogoUrl';


class Item extends PureComponent {
  constructor(props){
    super(props);
    this.state = {
      checkBoxValue: props.checked
    };
    this.handleOnChange = this.handleOnChange.bind(this);
    this.checkItem = createRef();
  }

  componentWillReceiveProps(nextProps){
    if(nextProps.checked !== this.props.checkBoxValue){
      this.setState({checkBoxValue: nextProps.checked});
    }
  }
  async handleOnChange(e){
    const {ch, onChange} = this.props;
    await this.setState(prevState=>{
      return {
        checkBoxValue: !prevState.checkBoxValue
      }
    })
    await onChange(this.checkItem.checked,ch);
    // onChange(e.nativeEvent.target.checked, ch);
  }
  
  render(){
    const {checkBoxValue} = this.state;
    const {ch, checked} = this.props;
    const imgWhite = _.keyBy(Config.logoUrl, 'epgId')[ch.epgId] && _.keyBy(Config.logoUrl, 'epgId')[ch.epgId].imgWhite;
      return (
        <div className='item' onClick={this.handleOnChange}>
        <input type="checkbox"
              id={ch.epgId}
              checked={checkBoxValue}
              readOnly
              // onChange={this.handleOnChange}
              ref={l=>this.checkItem = l }/>
        <label htmlFor={ch.chName}>
          {/* <img src={LogoUrl(ch.chName).imgWhite} alt='' /> */}
          <img src={imgWhite} alt={ch.chName} />
        </label>
      </div>
    )
  }
}

export default Item;


// WEBPACK FOOTER //
// ./src/components/select/item.js